<template>
  <section>
    <div class="form-content">
      <el-form-item label="资产明细">
        <section class="asset-list">
          <div class="r">
            <el-button @click="AddAsset()" type="primary" size="mini">添加需要处置的资产</el-button>
          </div>
          <div class="asset-table">
            <el-table :data="selectAssets" border>
              <el-table-column prop="number" label="资产编号" width="110px">
              </el-table-column>
              <!-- <el-table-column prop="name" label="资产名称">
              </el-table-column> -->
              <el-table-column label="资产名称">
                <template slot-scope="scope">
                  <span :style="(scope.row.status!='10'&&scope.row.status!='11')?'':'color:#f00'">
                    {{ "("+accessStatus[scope.row.status]+") "+scope.row.name }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="attribute.name" label="资产属性" width="90px">
              </el-table-column>
              <el-table-column prop="spec" label="规格型号" width="140px">
              </el-table-column>
              <el-table-column prop="price" label="购置金额" width="75px">
              </el-table-column>
              <el-table-column prop="purchaseTime" label="购置时间" width="110px">
              </el-table-column>

              <el-table-column label="操作" width="60" align="right">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="AssetDelete(scope.$index)" class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="申报单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目负责人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="处置形式">
            <el-select size="small" class="organization-select" v-model="form.type" placeholder="请选择资产处置形式">
              <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否三重一大">
            <el-radio v-model="form.szyd" label="1">是</el-radio>
            <el-radio v-model="form.szyd" label="0">否</el-radio>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="处置原因">
        <el-input type="textarea" placeholder="处置原因及目的" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>
      <el-form-item label="清理相关">
        <el-input type="textarea" placeholder="清理费用及清理收入说明" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.qlfy"></el-input>
      </el-form-item>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="买方单位">
            <el-input size="small" v-model="form.mfdw"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票号">
            <el-input size="small" v-model="form.invoice"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="金额">
            <el-input size="small" v-model="form.price"></el-input>
          </el-form-item>
        </el-col>
      </div>
    </div>

    <!-- 添加资产 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="selectAssetForm" :model="selectAssetForm" label-width="120px" class="form">
            <el-form-item label="转移资产">
              <el-select size="small" filterable class="organization-select" v-model="nowAssetId"
                placeholder="请选择需要转移的资产">
                <el-option v-for="item in assetList" :key="item.id" :label="item.name+'('+item.number+')'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        assetHandle: state => state.asset.assetHandle,
        organization: state => state.main.organization,
      })
    },
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        accessStatus: ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏", "即将过期", "过期"],
        typeArr: ['正常报废', '非正常报废', '损毁', '出售', '盘盈', '盘亏', '其他', ],

        selectAssetForm: {},
        selectAssets: [],
        nowAsset: {},
        nowAssetId: '',
        addType: 0,
        editIndex: '',

        addStatus: false,
      }
    },
    created() {
      this.selectAssets = this.assetHandle.data

      this.getAssetList()
    },
    mounted() {
      this.form = this.formByFather

      // 默认处置形式，是否正常报废
      for (let i = 0; i < this.selectAssets.length; i++) {
        if (this.selectAssets[i].status != 10 && this.selectAssets[i].status != 11) {
          this.form.type = '非正常报废'
        } else {
          this.form.type = '正常报废'
        }
      }
    },
    methods: {
      // 从列表里删除当前资产
      AssetDelete(index) {
        this.selectAssets.splice(index, 1)
      },
      // 显示添加资产弹窗
      AddAsset() {
        this.nowAsset = {}
        this.nowAssetId = ""
        this.addType = 0
        this.addStatus = true
      },
      // 添加资产到列表
      AddBtnClick() {
        for (let i = 0; i < this.assetList.length; i++) {
          let _item = this.assetList[i]
          if (_item.id == this.nowAssetId) {
            this.nowAsset = _item
          }
        }
        this.selectAssets.push(this.nowAsset)
        this.addStatus = false
      },
      // 获取资产基础资料列表
      getAssetList() {
        ajax.get('/asset/list', {
          'depId': this.userData.secDepIds.split(",")[0] / 1,
          'page': 0,
          'pageSize': 999999
        }, (res) => {
          this.loading = false
          this.assetList = res.vo.list
        })
      },
      // 返回form
      getFromData() {
        this.form.assetIds = this.selectAssets.map(item => item.id)
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        this.form.szyd = this.form.szyd + ''
        this.selectAssets = this.form.assets
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/asset/handle.vue